import { render, staticRenderFns } from "./BoxNumInput.vue?vue&type=template&id=77337e45"
import script from "./BoxNumInput.vue?vue&type=script&lang=js"
export * from "./BoxNumInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports